import { render, staticRenderFns } from "./purchaseReturnTask.vue?vue&type=template&id=7764e15e&scoped=true"
import script from "./purchaseReturnTask.vue?vue&type=script&lang=js"
export * from "./purchaseReturnTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnTask.vue?vue&type=style&index=0&id=7764e15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7764e15e",
  null
  
)

export default component.exports